import { Injectable } from '@angular/core';
import { LocaleService } from '@app/core/i18n';
import { LibraryUtilsService } from '@app/library/services/library-utils.service';
import { IUserData } from '@vestiaire/vc-angular-lib';

@Injectable()
export class UserUtilsService {
  constructor(public localeService: LocaleService, public libraryUtilsService: LibraryUtilsService) {}

  public prepareUserData(): IUserData {
    return {
      regionId: this.localeService.getRegion() || 4,
      countryCode: this.localeService.getCountry() || 'GB',
      langCode: this.libraryUtilsService.getLangCode(this.localeService.getTranslationKey()),
      atlasLangCode: this.localeService.getTranslationKey() || 'en',
      currencyCode: this.localeService.getCurrency() || 'GBP'
    };
  }
}
